import { localStorage } from 'storage4js'
import store from '@/store'

export function getToken () {
  return localStorage.getItem('X-YC-TOKEN')
}
export function setToken (token) {
  return localStorage.setItem('X-YC-TOKEN', token)
}
export function removeToken () {
  return localStorage.removeItem('X-YC-TOKEN')
}
export function getReToken () {
  return localStorage.getItem('X-YC-RETOKEN')
}
export function setReToken (reToken, refreshTokenExpire) {
  return localStorage.setItem('X-YC-RETOKEN', reToken, refreshTokenExpire)
}
export function removeReToken () {
  return localStorage.removeItem('X-YC-RETOKEN')
}
export function saveTokenAndReToken ({refreshToken, token, refreshTokenExpire}) {
  refreshToken && setReToken(refreshToken, refreshTokenExpire)
  token && setToken(token)
}
/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  removeToken()
  removeReToken()
  store.commit('REST_ZYPC_STORE')
}
